module.exports = __webpack_public_path__ + "static/media/kid7.3070b5c4.png";